const menu = require("../../../../../components/menu/menu");
const dtHandler = require("../../../../../components/dt/dt-handler");

export function start(detail, htmlDt, htmlFc) {
  //console.log('Menu Type 2 -> ', detail)

  const menuElem = menuBody[detail.id];

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc);
  }

  detail.html = menuElem;

  detail.act = "show";
  menu.start(detail);
}

const menuBody = {
  trMenu: [
    {
      text: "",
      svg: "eye",
      class: ``,
      dataDetail: ``,

      start: function (detail) {
        this.text = "View"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"providerProfit", "elem":"fullcont", "id":"providerProfit-fullcont", "act":"callData", "dbid": ${detail.dbid} },
                              {"dest":"providerProfit", "elem":"fullcont", "id":"providerProfit-fullcont", "act":"callUnpaidInvoices", "dbid": ${detail.dbid}}
           ]}'`;
      },
    },
  ],

  tableOptions: [
    {
      text: "",
      svg: "print",
      class: ``, //same name as the title test

      dataDetail: "",

      start: function (detail) {
        this.text = "Print All Provider Profits"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"providerProfit", "elem":"fullcont", "act":"printReportAll" }

        ]}'`;
      },
    },
  ],

  fullcontOptions: [
    {
      text: "",
      svg: "print",
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        //if exist one check
        this.class = ``;
        this.text = `Print Provider Profit`;
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"providerProfit", "elem":"fullcont", "act":"printReportOne"} ]}'`;
      } /**/,
    },
  ],
}; /*menuBody*/
